'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var PREFIX_CLS = exports.PREFIX_CLS = 'ant-fullcalendar';


/*****************
 ** WEBPACK FOOTER
 ** ./components/calendar/Constants.js
 ** module id = 92
 ** module chunks = 0
 **/